import { render, staticRenderFns } from "./AdvertisementsBlock.vue?vue&type=template&id=499e4a4e"
import script from "./AdvertisementsBlock.vue?vue&type=script&lang=js"
export * from "./AdvertisementsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports